module.exports = __webpack_public_path__ + "static/img/10.41c00b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/10.jpg
// module id = 8M3K
// module chunks = 1